import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 7px;\n  box-sizing: border-box;\n  color: ", ";\n  display: inline-flex;\n  font-size: ", "px;\n  font-weight: ", ";\n  height: 14px;\n  justify-content: center;\n  line-height: 14px;\n  min-width: 14px;\n  padding: 0 3px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { color, typography } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var BADGE_FONT_SIZE = 9;
var E2E_SUFFIX = '-badge';
/* Breaking the baseline rule here, because this is tiny stuff
 and makes a major impact regarding the design if used with baseline value */

var StyledBadge = styled.span(_templateObject(), color.indicator, color.palette.white, BADGE_FONT_SIZE, typography.fontWeightNormal);
/**
 * Badge/indicator to show count of something.
 *
 * @example ./__docs__/Badge.md
 */

export function Badge(_ref) {
  var count = _ref.count,
      _ref$showEmpty = _ref.showEmpty,
      showEmpty = _ref$showEmpty === void 0 ? false : _ref$showEmpty,
      title = _ref.title;
  if (!count && !showEmpty) return null;
  return React.createElement(StyledBadge, {
    title: title,
    "data-e2e": getE2eLabel(title, E2E_SUFFIX)
  }, count);
}